import {Box} from "@mui/material";
import {ExecutionStatus} from "crqlar-react-common/dist/models/automation/automation";
import React from "react";
import {useTranslation} from "react-i18next";
import {ElementChip} from "./base/ElementChip";
import {getExecutionStatusColor} from "./colors";

export const EXECUTION_STATUS_LABEL_KEYS: Record<ExecutionStatus, string> = {
    [ExecutionStatus.PENDING]: 'Pending',
    [ExecutionStatus.RUNNING]: 'Running',
    [ExecutionStatus.WAITING]: 'Waiting',
    [ExecutionStatus.COMPLETED]: 'Completed',
    [ExecutionStatus.FAILED]: 'Failed',
    [ExecutionStatus.CANCELLED]: 'Execution status CANCELLED',
};

type ExecutionStatusElementProps = {
    status: ExecutionStatus | undefined;
    asPrint?: boolean;
};

export function ExecutionStatusElement({status, asPrint = false}: ExecutionStatusElementProps) {
    const {t} = useTranslation();

    if (!status) {
        return null;
    }

    const text = t(EXECUTION_STATUS_LABEL_KEYS[status] ?? status);

    if (asPrint) {
        return <>{text}</>;
    }

    return (
        <Box sx={{display: "inline-flex", maxWidth: "100%"}}>
            <ElementChip
                text={text}
                startIcon={
                    <Box
                        component="span"
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            bgcolor: getExecutionStatusColor(status),
                            flex: "0 0 auto",
                        }}
                    />
                }
            />
        </Box>
    );
}
